// @flow

import {Tag} from 'docs/util';
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CountryName: MarkdocTagRegistration = {
  tag: 'country-name',
  component: 'CountryName',
  attributes: {
    code: {
      type: String,
      required: true,
      description: 'ISO country code (e.g. US)',
    },
    include_article: {
      type: Boolean,
      default: false,
      description:
        'Whether to format the country name with a definitive article (useful when iterating over loops)',
    },
    countries: {
      type: Array,
      description:
        'A map of ISO country code <> formatted country name. If left out, will default to the countries list from the $ungated_countries context',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);

    // Default to our list of ungated (publicly available countries) if a country list is not passed in
    if (!attributes.countries && config?.variables?.ungated_countries) {
      const countriesFromContext = config?.variables?.ungated_countries;
      if (countriesFromContext || countriesFromContext.countries) {
        attributes.countries = countriesFromContext.countries || [];
      }
    }

    return new Tag(this.tag, attributes);
  },
};
